import { IconButton, IconButtonProps, Tooltip } from '@material-ui/core';
import { LoadingRing } from 'components/Loading/Loading';
import React, { MouseEventHandler } from 'react';

interface TableActionProps extends IconButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>,
  title: string,
  children: React.ReactNode,
  loading?: boolean
}
const TableAction = React.forwardRef<HTMLButtonElement, TableActionProps>((props: TableActionProps, ref) => {
  const { onClick, title, children, loading, ...rest } = props;
  return <Tooltip title={title}>
    <span>
      <IconButton
        onClick={onClick}
        ref={ref}
        {...rest}
      >
        {loading ? <LoadingRing/>:children}
      </IconButton>
    </span>
  </Tooltip>
});

TableAction.displayName = 'TableAction';
export default TableAction;